module.exports = __webpack_public_path__ + "static/media/success.d3e44d1f.png";